<template>
    <v-card v-bind="$attrs">
        <v-card-title class="d-flex align-center px-6 py-4">
            <div class="font-weight-bold mr-auto">Account Link</div>
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" @click="$emit('cancel')" v-on="on">{{ mdiClose }} </v-icon>
                    </template>
                    <span>Cancel</span>
                </v-tooltip>
            </div>
        </v-card-title>
        <v-card-text>
            <v-text-field
                v-model="oldEmail"
                v-bind="$attrs"
                label="Old Email"
                outlined
                dense
                clearable
                :disabled="value.verified"
            />
            <v-text-field
                v-if="showCode"
                v-model="code"
                v-bind="$attrs"
                label="Verification Code"
                outlined
                dense
                clearable
                :disabled="value.verified"
            />
        </v-card-text>
        <div class="justify-end mb-4" :class="$vuetify.breakpoint.smAndDown ? 'flex-column mx-4' : 'd-flex mr-4'">
            <v-btn
                :block="$vuetify.breakpoint.smAndDown"
                text
                :class="!$vuetify.breakpoint.smAndDown ? 'mr-2' : 'mb-2 px-3'"
                v-bind="$attrs"
                @click="cancel"
                >Cancel</v-btn
            >
            <v-btn
                :block="$vuetify.breakpoint.smAndDown"
                :class="!$vuetify.breakpoint.smAndDown ? 'mr-2' : 'mb-2 px-3'"
                color="primary"
                text
                :disabled="!oldEmail || value.verifiedAt"
                v-bind="$attrs"
                @click="submit"
            >
                {{ showCode ? 'Verify' : 'Send Code' }}
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import { mdiClose } from '@mdi/js'
import gql from 'graphql-tag'

export default {
    name: 'AccountLinkedAccountEdit',
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            mdiClose,
            oldEmail: null,
            code: null,
            loading: false,
            showCode: false
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.reset(newVal)
            }
        }
    },
    methods: {
        reset(val) {
            this.oldEmail = val.email
            this.code = null
            this.showCode = !!val.createdAt
        },
        cancel() {
            this.$emit('cancel')
            this.reset(this.value)
        },
        submit() {
            if (this.code) {
                this.submitVerification(this.code)
            } else {
                this.submitLinkRequest()
            }
        },
        submitLinkRequest() {
            this.loading = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation requestAccountLinkCode($oldEmail: String!) {
                            requestAccountLinkCode(oldEmail: $oldEmail) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        oldEmail: this.oldEmail.trim()
                    }
                })
                .then((data) => {
                    const notification = data.data.requestAccountLinkCode.success
                        ? 'Account link request successfully sent. Please check your email for the verification code.'
                        : 'Failed to request account link code. Please try again later or contact support.'
                    this.$store.dispatch(`notification/set`, notification)
                    if (data.data.requestAccountLinkCode.success) {
                        this.showCode = true
                    }
                    this.$emit('save')
                })
                .catch((e) => {
                    console.error(e)
                    this.$store.dispatch(
                        `notification/set`,
                        'An error occurred while requesting account link code. Please try again later or contact support.'
                    )
                })
                .finally(() => {
                    this.loading = false
                })
        },
        submitVerification(code) {
            this.loading = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation verifyAccountLinkCode($code: String!, $oldEmail: String!) {
                            verifyAccountLinkCode(code: $code, oldEmail: $oldEmail) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        oldEmail: this.oldEmail.trim(),
                        code: code.trim()
                    }
                })
                .then((data) => {
                    const notification = data.data.verifyAccountLinkCode.success
                        ? 'Account link verification successfully completed.'
                        : 'Failed to verify account link code. Please try again later or contact support.'
                    this.$store.dispatch(`notification/set`, notification)
                    this.$emit('completed')
                })
                .catch((e) => {
                    console.error(e)
                    this.$store.dispatch(
                        `notification/set`,
                        'An error occurred while verifying account link code. Please try again later or contact support.'
                    )
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
